import {put, putResolve, takeLatest} from 'redux-saga/effects';

import {PrescriptionType} from '../../reducers/prescription/prescription/prescriptionTypes';
import {
    fetchSavedCustomerPrescriptions,
    saveCustomerPrescription,
    startSavePrescriptionSaga,
    updateCustomerPrescription,
} from '../../reducers/prescription/savedCustomerPrescription/savedCustomerPrescription';
import {preparePrescriptionToUpdate} from '../../utils/prescription/prescription';

/**
 * Save prescription saga
 * @param {Object} action - prescription to save
 */
export function* savePrescription(action: {
    payload: {
        prescription: PrescriptionType;
        isUpdate: boolean;
    };
}) {
    try {
        const {prescription, isUpdate} = action.payload;
        if (isUpdate) {
            yield putResolve(updateCustomerPrescription(preparePrescriptionToUpdate(prescription)));
        } else {
            yield putResolve(saveCustomerPrescription(prescription));
        }
        yield put(fetchSavedCustomerPrescriptions());
    } catch (e) {
        console.error(e); // eslint-disable-line no-console
    }
}

/**
 * Root
 */
export function* prescriptionSaga() {
    yield takeLatest(startSavePrescriptionSaga, savePrescription);
}
